import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { PriceListItemList } from '../../priceList/components/PriceListItemList';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejPriceListPage = () => {
  const { apps, customerType } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej && customerType === 'ipr' ? (
        <AppWrapper
          appType={APP_TYPE.VYDEJ}
          menu={<VydejMenu />}
          resource='PriceListItems'
          action='retrieve'
        >
          <PriceListItemList />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejPriceListPage;
